/**
 * Nhãn một đơn vị theo id — cho ô lọc, cột và ngăn kéo chi tiết.
 *
 * Thứ tự nguồn: tên CHỤP lúc ghi (đúng tên người tra cứu còn nhớ) → danh bạ phòng ban của tenant
 * (`GET /api/v1/departments`, ADR-0067 — native là `/api/directory/organizations`) → mã rút gọn. Ở platform
 * `actor_don_vi_id` là `department_id` (ADR-0095 mục 4) và module không chụp tên đơn vị, nên danh bạ là nguồn chính.
 */

const SO_KY_TU_MA = 8;

export function maRutGon(id: string): string {
  return id.length > SO_KY_TU_MA ? `${id.slice(0, SO_KY_TU_MA)}…` : id;
}

export function nhanDonVi(id: string, danhBa: ReadonlyMap<string, string>, tenChup?: string | null): string {
  return tenChup || danhBa.get(id) || maRutGon(id);
}
